var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133219)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_422_133219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4995 35.3759V41.5524M29.529 34.3465C29.5353 34.4854 29.5135 34.6241 29.4647 34.7544C29.416 34.8846 29.3413 35.0036 29.2453 35.1042C29.1493 35.2048 29.0339 35.2849 28.9061 35.3397C28.7783 35.3945 28.6407 35.4228 28.5016 35.4229C28.3626 35.4231 28.2249 35.395 28.097 35.3405C27.9691 35.286 27.8535 35.2061 27.7573 35.1057C27.6611 35.0053 27.5862 34.8864 27.5372 34.7563C27.4882 34.6262 27.4661 34.4874 27.4722 34.3485C27.4838 34.0837 27.597 33.8336 27.7884 33.6502C27.9798 33.4668 28.2345 33.3643 28.4996 33.3641C28.7646 33.3638 29.0196 33.4658 29.2113 33.6488C29.4031 33.8318 29.5168 34.0817 29.529 34.3465Z",
    stroke: "#0B132B",
    strokeWidth: 2.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9998 23.0228H10.9995V51.8466H45.9998V23.0228ZM17.176 15.8169C17.176 9.56312 22.2459 4.49323 28.4997 4.49323C34.7534 4.49323 39.8233 9.56312 39.8233 15.8169V23.0228H17.176V15.8169Z",
    stroke: "#0B132B",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_422_133219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc7);
export default __webpack_public_path__ + "static/media/doc7.b724c942c1ae9832d4c2f81b80c06e4b.svg";
export { ForwardRef as ReactComponent };